import LineGradient from "../components/LineGradient";
import {motion} from "framer-motion";
const container = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.2 }
    }
};

const projectVariant = {
    hidden: { opacity: 0, scale:0.8 },
    visible: {
        opacity: 1,
        scale: 1
    }
}

const Project = ({title,subtitle}) => {
const overlayStyles = "absolute w-full h-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue ";
const projectTitle=title.split(" ").join("-").toLowerCase();

    return(
        <motion.div variants={projectVariant} className="relative">
            <div className={overlayStyles}>
            <p className="text-2xl font-playfair">{title}</p>
            <p className="mt-7">{subtitle}</p>
            </div>
            <img src={`../assets/${projectTitle}.png`} alt={projectTitle} />
        </motion.div>

    )

}

const Projects = () => {
    return(
        <section id="projects" className="pt-48 pb-48">

            {/* headings */}
            <motion.div
                className="md:w-2/4 mx-auto text-center"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{duration: 0.5}}
                variants={{
                    hidden: {opacity: 0, y: -50},
                    visible: {opacity: 1, y: 0}
                }}
                >

                    <div>
                        <p
                        className="font-acorn font-semibold text-4xl"
                        >
                        MY <span className="text-red">PROJECTS</span>
                        </p>
                        <div className="flex justify-center mt-5">
                            <LineGradient width="1/3" />
                        </div>
                        
                    </div>
                    
                    
                    <p
                    className="mt-10 mb-10"
                    >
                        Here are some of the projects I’ve worked on, covering web development, AI, and embedded systems. 
                        JEach project represents my hands-on approach to creating effective solutions.
                    </p>
                </motion.div>


                {/* project cards */}
                <div className="flex justify-center">
                <motion.div
                className="sm:grid sm:grid-cols-3"
                initial="hidden"
                whileInView="visible"
                viewport={{once: true, amount: 0.5}}
                transition={{duration: 0.5}}
                variants={container}
                >
                    {/* Row 1 */}
                    <div className="flex justify-center text-center items-center p-10 bg-red max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold">
                    A glimpse into my tech-driven projects.
                    </div>
                    <Project title="Bird Observation System" subtitle="An AI-driven system that detects and tracks bird species using sound localization and PTZ modules." />
                    <Project title="Image Caption Generator" subtitle="Generates descriptive captions for images using EfficientNet and TensorFlow for real-time insights." />

                    {/* Row 2 */}
                    <Project title="Youtube Summary Generator" subtitle="Automatically creates concise summaries for YouTube videos with NLP techniques in Node.js." />
                    <Project title="WhatsApp Newsbot" subtitle="A chatbot that delivers news updates directly to WhatsApp, keeping users informed." />
                    <Project title="Know Your Professor" subtitle="A RAG-LLM model that provides detailed information on UM-Dearborn professors." />

                    {/* Row 3 */}
                    <Project title="Pet Services" subtitle="A marketplace connecting pet owners with local services and supplies." />
                    <Project title="Commute Assistant" subtitle="A Google Assistant applet that offers real-time university shuttle notifications." />
                    <div className="flex justify-center text-center items-center p-10 bg-blue max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold">
                    Appreciate your time—let’s build together.
                    </div>
                </motion.div>
                </div>
        </section>

    )
}

export default Projects;